import styled from 'styled-components'

export const StyledActionSheet = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 101;
  font-size: 15px;

  .lon-action-sheet {
    &__container {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 101;
      font-size: 15px;
      transition: all cubic 0.2s;
    }

    &__list {
      margin: 0 10px;
      background-color: #fff;
      border-radius: 12px;
    }

    &__item {
      margin: 0 10px;
      color: #5f4dbc;

      &:not(:last-of-type) {
        border-bottom: 0.5px solid #eaecf6;
      }
    }

    &__item,
    &__cancel {
      background: #fff;
      padding: 15px 0;
    }

    &__cancel {
      margin: 10px;
      margin-bottom: env(safe-area-inset-bottom);
      border-radius: 12px;
    }

    &__content {
      position: absolute;
      bottom: 10px;
      left: 0;
      right: 0;
      text-align: center;
    }
  }
`
